<template>
  <div class="rex-progress">
    <div
      class="rex-progress-inner"
      :style="`width:${precent}%;background-color: ${color};`"
    ></div>
  </div>
</template>

<script>
/**
 * A progress bar
 */
export default {
  name: 'RexProgress',
  props: {
    /**
     * how much part of progress bar need to be filled
     * `0-100`
     */
    precent: {
      default: '0'
    },
    /**
     * color of filled progress bar
     */
    color: {
      default: ''
    }
  }
};
</script>
<style lang="scss" scoped>
.rex-progress {
  height: 0.3125rem;
  border-radius: 0.5rem;
  background-color: $progress-inactive-color;
  width: 100%;
}
.rex-progress-inner {
  height: 100%;
  border-radius: 0.125rem;
  background-color: $progress-active-color;
}
</style>
